"use strict";

var cov_1woulnfoz5 = function () {
  var path = "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/application-bar/FileMenu.js";
  var hash = "47908aa1d19453fe51a9986f29a5a145ca99ea60";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/application-bar/FileMenu.js",
    statementMap: {
      "0": {
        start: {
          line: 24,
          column: 2
        },
        end: {
          line: 50,
          column: 4
        }
      },
      "1": {
        start: {
          line: 42,
          column: 14
        },
        end: {
          line: 42,
          column: 26
        }
      },
      "2": {
        start: {
          line: 53,
          column: 0
        },
        end: {
          line: 63,
          column: 1
        }
      },
      "3": {
        start: {
          line: 65,
          column: 24
        },
        end: {
          line: 65,
          column: 67
        }
      }
    },
    fnMap: {
      "0": {
        name: "FileMenuComponent",
        decl: {
          start: {
            line: 21,
            column: 9
          },
          end: {
            line: 21,
            column: 26
          }
        },
        loc: {
          start: {
            line: 23,
            column: 3
          },
          end: {
            line: 51,
            column: 1
          }
        },
        line: 23
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 41,
            column: 21
          },
          end: {
            line: 41,
            column: 22
          }
        },
        loc: {
          start: {
            line: 41,
            column: 27
          },
          end: {
            line: 43,
            column: 13
          }
        },
        line: 41
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "47908aa1d19453fe51a9986f29a5a145ca99ea60"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileMenu = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

var _repository = require("../repository");

var _treeBlob = require("../tree-blob");

var _helpers = require("./helpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function FileMenuComponent(_ref) {
  var blob = _ref.blob;
  cov_1woulnfoz5.f[0]++;
  cov_1woulnfoz5.s[0]++;
  return _react.default.createElement(_core.List, {
    dense: true
  }, _react.default.createElement(_core.ListItem, {
    alignItems: "flex-start",
    ContainerComponent: "div",
    button: true
  }, _react.default.createElement(_core.ListItemIcon, {
    style: {
      marginRight: 0
    }
  }, _react.default.createElement(_icons.Note, null)), _react.default.createElement(_core.ListItemText, {
    primary: blob.filepath,
    secondary: (0, _helpers.humanFileSize)(blob.size)
  }), _react.default.createElement(_core.ListItemSecondaryAction, null, _react.default.createElement(_core.IconButton, {
    "aria-label": "Open Link",
    onClick: function onClick() {
      cov_1woulnfoz5.f[1]++;
      cov_1woulnfoz5.s[1]++;
      blob.close();
    }
  }, _react.default.createElement(_icons.Cancel, null)))));
}

cov_1woulnfoz5.s[2]++;
FileMenuComponent.propTypes = {
  /** Blob data to render, if url not provided. */
  blob: _propTypes.default.shape({
    /** The filepath in the Git Tree Blob Object */
    path: _propTypes.default.string.isRequired,

    /** The url in the Git Tree Blob Object */
    url: _propTypes.default.string,

    /** The content size of the Git Tree Blob Object */
    size: _propTypes.default.number
  })
};
var FileMenu = (cov_1woulnfoz5.s[3]++, (0, _repository.withRepository)((0, _treeBlob.withBlob)(FileMenuComponent)));
exports.FileMenu = FileMenu;